(function () {
  'use strict';

  /* ═══════════════════════════════════════
     WASHI TAPE PREVIEW — 15mm × 80mm (fixed)
     Marpple structure:
       · outer black dashed box = full tape (with light margins)
       · dark band = chosen bg color (full width, center)
       · light margins above/below = lighter tint of bg color
       · green dashed = top & bottom edges of the dark band
       · paper grain over the whole tape
       · faded side repeats
  ═══════════════════════════════════════ */

  var PX_PER_MM        = 4;
  var PREVIEW_H_SCALE  = 3.6;   /* fatten tape vertically */
  var GRAIN_ALPHA      = 0.02;  /* paper-grain strength */
  var TAPE_MM          = 15;
  var LEN_FIXED        = 80;
  var RULER_LEFT       = 26;
  var RULER_BOTTOM     = 20;

  var BAND_RATIO       = 0.66;  /* dark band height as fraction of total (rest = light margins) */
  var LIGHT_MIX        = 0.55;  /* how much white mixed into margin tint (0=band color, 1=white) */

  var SIDE_RATIO          = 0.32;
  var GHOST_OPACITY       = 0.35;
  var MOBILE_CENTER_SHARE = 0.60;

  /* ─── COLOR MAPS ─── */
  var COLOR_MAP = {
    black: '#000000', white: '#ffffff', navy: '#1a2e5a',
    blue:  '#4db8e8', green: '#2d6e3e', pink: '#f4a7c3', brown: '#8b5e3c'
  };
  var BG_MAP = {
    white: '#ffffff', cream: '#fff6dc', butter: '#fff0a6', peach: '#ffd8c2',
    pink:  '#ffd4e3', lavender: '#e3d8ff', mint: '#d2f2e4', sky: '#d4ebff',
    gray:  '#e6e6e6', kraft: '#d8b98b'
  };

  /* ─── FONT MAPS ─── */
  var FONT_MAP = {
    'Nunito':           "'Nunito', sans-serif",
    'Cloudsofa':        "'Cloudsofa', cursive",
    'Ownglyph_PDH':     "'Ownglyph_PDH', cursive",
    'Genty':            "'Baloo 2', cursive",
    'Fredoka':          "'Fredoka One', cursive",
    'Baloo 2':          "'Baloo 2', cursive",
    'Poppins ExtraBold':"'Poppins', sans-serif",
    'Bubblegum Sans':   "'Bubblegum Sans', cursive",
    'Quicksand Bold':   "'Quicksand', sans-serif",
    'Chewy':            "'Chewy', cursive",
    'Cooper Black':     "'Cooper Black', serif",
    'Balsamiq Sans':    "'Balsamiq Sans', cursive",
    'BMJUA':            "'Jua', sans-serif",
    'Comic Sans':       "'Comic Sans MS', cursive",
    'Cursive':          "'Dancing Script', cursive",
    'Poppins Bold':     "'Poppins', sans-serif",
    'Josefin Sans':     "'Josefin Sans', sans-serif",
    'Paytone One':      "'Paytone One', cursive",
    'Titan One':        "'Titan One', cursive",
    'Lilita One':       "'Lilita One', cursive",
    'Sacramento':       "'Sacramento', cursive",
    'Great Vibes':      "'Great Vibes', cursive",
    'Pacifico':         "'Pacifico', cursive",
    'Satisfy':          "'Satisfy', cursive",
    'Yellowtail':       "'Yellowtail', cursive",
    'Comfortaa':        "'Comfortaa', cursive"
  };
  var FONT_WEIGHT = {
    'Poppins ExtraBold': '800',
    'Poppins Bold':      '700',
    'Quicksand Bold':    '700',
    'Josefin Sans':      '700'
  };

     /* fonts that unlock bonus icon glyphs — banner shown when picked */
  var FONT_HINT = {
    'Ownglyph_PDH': 'Try the hidden cat icons! 🐱 Tap to copy, then add it to your name: ♤ ♧ † £ ¢'
  };
  var FONT_HINT_CHARS = {
    'Ownglyph_PDH': ['♤', '♧', '†', '£', '¢']
  };

  /* ─── STATE ─── */
  var state = {
    firstName:  'Your name',
    lastName:   '',
    color:      '#000000',
    bgColor:    '#ffffff',
    fontFamily: "'Nunito', sans-serif",
    fontWeight: '700'
  };

  function isMobile() { return window.innerWidth <= 600; }
  function patternLenMM() { return LEN_FIXED; }

  /* mix a hex color toward white by t (0..1) */
  function lighten(hex, t) {
    var n = parseInt(hex.slice(1), 16);
    var r = n >> 16 & 255, g = n >> 8 & 255, b = n & 255;
    r = Math.round(r + (255 - r) * t);
    g = Math.round(g + (255 - g) * t);
    b = Math.round(b + (255 - b) * t);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }

  /* text measuring */
  var measureCtx = document.createElement('canvas').getContext('2d');
  function measure(text, fs, family, weight) {
    measureCtx.font = weight + ' ' + fs + 'px ' + family;
    return measureCtx.measureText(text).width;
  }
  function fitFs(text, startFs, minFs, availW) {
    var fs = startFs;
    while (fs > minFs && measure(text, fs, state.fontFamily, state.fontWeight) > availW) fs--;
    return fs;
  }

  /* paper grain painted over an element */
  function addGrain(host, w, h) {
    var cw = Math.max(2, Math.round(w / 2));
    var ch = Math.max(2, Math.round(h / 2));
    var c = document.createElement('canvas');
    c.width = cw; c.height = ch;
    c.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;mix-blend-mode:multiply;z-index:1;';
    var ctx = c.getContext('2d');
    var img = ctx.createImageData(cw, ch);
    for (var i = 0; i < img.data.length; i += 4) {
      var v = 255 - Math.floor(Math.random() * 255 * GRAIN_ALPHA);
      img.data[i] = img.data[i+1] = img.data[i+2] = v;
      img.data[i+3] = 255;
    }
    ctx.putImageData(img, 0, 0);
    host.appendChild(c);
  }

  /* Build ONE tape repeat unit:
       host = positioned box (w × h). Draws light bg, dark band, grain, text.
     opts.marks = true → also draw black cut box + green band edges. */
  function buildTape(w, h, opts) {
    opts = opts || {};
    var firstName = state.firstName || 'Your name';
    var lastName  = state.lastName  || '';
    var hasTwo    = lastName.length > 0;

    var bandH  = Math.round(h * BAND_RATIO);
    var bandTop= Math.round((h - bandH) / 2);
    var lightC = lighten(state.bgColor, LIGHT_MIX);

    var unit = document.createElement('div');
    unit.style.cssText = 'position:absolute;width:' + w + 'px;height:' + h +
      'px;overflow:hidden;box-sizing:border-box;background:' + lightC + ';';

    /* dark band (chosen color) */
    var band = document.createElement('div');
    band.style.cssText = 'position:absolute;left:0;right:0;top:' + bandTop + 'px;height:' + bandH +
      'px;background:' + state.bgColor + ';';
    unit.appendChild(band);

    /* grain over the whole tape */
    addGrain(unit, w, h);

    /* text (centered in the band) */
    var hPad = w * 0.05;
    var availW = w - hPad * 2;
    var fs1, fs2;
    if (!hasTwo) {
      fs1 = fitFs(firstName, Math.round(bandH * 0.62), 8, availW);
    } else {
      fs1 = fitFs(firstName, Math.round(bandH * 0.46), 8, availW);
      fs2 = fitFs(lastName,  Math.round(bandH * 0.38), 7, availW);
      fs2 = Math.min(fs2, fs1);
    }
    var txt = document.createElement('div');
    txt.style.cssText = 'position:absolute;left:0;right:0;top:' + bandTop + 'px;height:' + bandH +
      'px;display:flex;flex-direction:column;align-items:center;justify-content:center;z-index:2;padding:0 ' + hPad + 'px;box-sizing:border-box;';
    var l1 = document.createElement('span');
    l1.textContent = firstName;
    l1.style.cssText = 'font-size:' + fs1 + 'px;color:' + state.color + ';font-family:' + state.fontFamily +
      ';font-weight:' + (state.fontWeight||'700') + ';white-space:nowrap;line-height:1.02;max-width:100%;';
    txt.appendChild(l1);
    if (hasTwo) {
      var l2 = document.createElement('span');
      l2.textContent = lastName;
      l2.style.cssText = 'font-size:' + fs2 + 'px;color:' + state.color + ';font-family:' + state.fontFamily +
        ';font-weight:' + (state.fontWeight||'700') + ';white-space:nowrap;line-height:1.02;max-width:100%;';
      txt.appendChild(l2);
    }
    unit.appendChild(txt);

    if (opts.marks) {
      /* outer black dashed box = full tape edge */
      var cut = document.createElement('div');
      cut.style.cssText = 'position:absolute;inset:0;border:1.5px dashed #333;pointer-events:none;box-sizing:border-box;z-index:3;';
      unit.appendChild(cut);
      /* green dashed = top & bottom edges of the dark band (horizontal only) */
      var gTop = document.createElement('div');
      gTop.style.cssText = 'position:absolute;left:0;right:0;top:' + bandTop + 'px;border-top:1.5px dashed #4caf50;pointer-events:none;z-index:3;';
      unit.appendChild(gTop);
      var gBot = document.createElement('div');
      gBot.style.cssText = 'position:absolute;left:0;right:0;top:' + (bandTop + bandH) + 'px;border-top:1.5px dashed #4caf50;pointer-events:none;z-index:3;';
      unit.appendChild(gBot);
    }

    return unit;
  }

  /* ══════════════════════════════════════
     DESKTOP PREVIEW
  ══════════════════════════════════════ */
  function renderPreview() {
    var lenMM  = patternLenMM();
    var labelW = lenMM * PX_PER_MM;
    var labelH = Math.round(TAPE_MM * PX_PER_MM * PREVIEW_H_SCALE);
    var sideW  = Math.round(labelW * SIDE_RATIO);

    var mobile = isMobile();
    var totalW = mobile ? labelW : labelW + sideW * 2 + RULER_LEFT;
    var totalH = mobile ? labelH : labelH + RULER_BOTTOM;

    var xAxis = document.getElementById('ruler-x-axis');
    var yAxis = document.getElementById('ruler-y-axis');
    if (xAxis) xAxis.style.display = mobile ? 'none' : '';
    if (yAxis) yAxis.style.display = mobile ? 'none' : '';

    var wrap = document.getElementById('xl-preview-wrap');
    wrap.style.width  = totalW + 'px';
    wrap.style.height = totalH + 'px';

    var cv = document.getElementById('xl-label-canvas');
    cv.style.border = 'none';
    cv.style.zIndex = '0';
    cv.width = 1; cv.height = 1;

    var grid = document.getElementById('xl-label-grid');
    grid.style.left     = mobile ? '0' : RULER_LEFT + 'px';
    grid.style.top      = '0';
    grid.style.width    = (mobile ? labelW : labelW + sideW * 2) + 'px';
    grid.style.height   = labelH + 'px';
    grid.style.overflow = 'hidden';
    grid.innerHTML      = '';

    var centerLeft = mobile ? 0 : sideW;

    if (!mobile) {
      var gl = buildTape(labelW, labelH, {});
      var gr = buildTape(labelW, labelH, {});
      gl.style.left = (centerLeft - labelW) + 'px'; gl.style.top = '0'; gl.style.opacity = GHOST_OPACITY;
      gr.style.left = (centerLeft + labelW) + 'px'; gr.style.top = '0'; gr.style.opacity = GHOST_OPACITY;
      grid.appendChild(gl); grid.appendChild(gr);
    }
    var center = buildTape(labelW, labelH, { marks: true });
    center.style.left = centerLeft + 'px'; center.style.top = '0'; center.style.zIndex = '2';
    grid.appendChild(center);

    renderRulers(labelW, labelH, lenMM, sideW);
  }

  function renderRulers(labelW, labelH, lenMM, sideW) {
    var xAxis = document.getElementById('ruler-x-axis');
    xAxis.innerHTML = '';
    xAxis.style.cssText = 'position:absolute;left:' + (RULER_LEFT + sideW) + 'px;top:' + labelH + 'px;width:' + labelW + 'px;height:' + RULER_BOTTOM + 'px;';
    var stepMM = 20;
    for (var x = 0; x <= lenMM; x += stepMM) {
      var tk = document.createElement('span');
      tk.className = 'tick-x';
      tk.textContent = x;
      tk.style.left = (x * PX_PER_MM - 3) + 'px';
      tk.style.top  = '3px';
      xAxis.appendChild(tk);
    }
    var xl = document.createElement('span');
    xl.textContent = '0 (mm)';
    xl.style.cssText = 'position:absolute;left:-22px;top:3px;font-size:9px;color:#999;';
    xAxis.appendChild(xl);

    var yAxis = document.getElementById('ruler-y-axis');
    yAxis.innerHTML = '';
    yAxis.style.cssText = 'position:absolute;left:0;top:0;width:' + RULER_LEFT + 'px;height:' + labelH + 'px;';
    var steps = 3;
    for (var iy = 0; iy <= steps; iy++) {
      var ty = document.createElement('span');
      ty.className = 'tick-y';
      ty.textContent = Math.round(TAPE_MM - iy * (TAPE_MM / steps));
      ty.style.right = '3px';
      ty.style.top   = (iy * (labelH / steps) - 6) + 'px';
      yAxis.appendChild(ty);
    }
  }

  /* ══════════════════════════════════════
     MOBILE PREVIEW
  ══════════════════════════════════════ */
  function renderMobilePreview() {
    var col = document.querySelector('.xl-preview-col');
    if (!col) return;
    var mPrev = document.getElementById('xl-mobile-preview');
    if (!mPrev) {
      mPrev = document.createElement('div');
      mPrev.id = 'xl-mobile-preview';
      col.appendChild(mPrev);
    }

    var lenMM   = patternLenMM();
    var outerW  = col.getBoundingClientRect().width || window.innerWidth * 0.90;
    var centerW = Math.round(outerW * MOBILE_CENTER_SHARE);
    var sideW   = Math.round((outerW - centerW) / 2);
    var H       = Math.round(centerW * (TAPE_MM / lenMM) * PREVIEW_H_SCALE);

    mPrev.style.cssText = 'display:block;width:' + outerW + 'px;height:' + H +
      'px;position:relative;overflow:hidden;';
    mPrev.innerHTML = '';

    var gl = buildTape(centerW, H, {});
    var gr = buildTape(centerW, H, {});
    gl.style.left = (sideW - centerW) + 'px'; gl.style.top = '0'; gl.style.opacity = GHOST_OPACITY;
    gr.style.left = (sideW + centerW) + 'px'; gr.style.top = '0'; gr.style.opacity = GHOST_OPACITY;
    mPrev.appendChild(gl); mPrev.appendChild(gr);

    var center = buildTape(centerW, H, { marks: true });
    center.style.left = sideW + 'px'; center.style.top = '0'; center.style.zIndex = '2';
    mPrev.appendChild(center);

    var guide = document.getElementById('xl-mobile-size-guide');
    if (!guide) {
      guide = document.createElement('div');
      guide.id = 'xl-mobile-size-guide';
      guide.style.cssText = 'text-align:center;font-size:12px;color:#aab8c2;margin-top:8px;font-family:Helvetica Neue,sans-serif;letter-spacing:0.5px;';
      col.appendChild(guide);
    }
    guide.style.display = '';
    guide.textContent = TAPE_MM + 'mm × ' + lenMM + 'mm';
  }

  function scalePreview() {
    var col    = document.querySelector('.xl-preview-col');
    var scaler = document.getElementById('xl-preview-scaler');
    if (!col || !scaler) return;

    if (isMobile()) {
      scaler.style.display = 'none';
      renderMobilePreview();
      col.style.height = '';
      return;
    }

    scaler.style.display = '';
    var mPrev = document.getElementById('xl-mobile-preview');
    if (mPrev) mPrev.style.display = 'none';
    var guide = document.getElementById('xl-mobile-size-guide');
    if (guide) guide.style.display = 'none';

    var lenMM    = patternLenMM();
    var labelW   = lenMM * PX_PER_MM;
    var sideW    = Math.round(labelW * SIDE_RATIO);
    var naturalW = labelW + sideW * 2 + RULER_LEFT;
    var naturalH = Math.round(TAPE_MM * PX_PER_MM * PREVIEW_H_SCALE) + RULER_BOTTOM;
    var colW     = col.getBoundingClientRect().width;
    if (colW === 0) return;

    var scale = colW / naturalW;
    scaler.style.transform       = 'scale(' + scale + ')';
    scaler.style.transformOrigin = 'top left';
    col.style.height = Math.round(naturalH * scale) + 'px';
  }

  function refresh() {
    var pl = document.getElementById('hidden-pattern-length');
    if (pl) pl.value = patternLenMM() + 'mm';
    renderPreview();
    setTimeout(scalePreview, 20);
  }

  /* ══════════════════════════════════════
     SECTION 1: NAME TEXT
  ══════════════════════════════════════ */
  function updateCharCount(inputEl, countEl) {
    var len = inputEl.value.length;
    var max = parseInt(inputEl.getAttribute('maxlength')) || 12;
    countEl.textContent = len + '/' + max;
    countEl.classList.remove('warn', 'limit');
    if (len >= max)          countEl.classList.add('limit');
    else if (len >= max - 2) countEl.classList.add('warn');
  }
  function onNameInput() {
    var fnEl = document.getElementById('first-name');
    var lnEl = document.getElementById('last-name');
    state.firstName = ((fnEl && fnEl.value) || '').trim() || 'Your name';
    state.lastName  = ((lnEl && lnEl.value) || '').trim();
    var fnCount = document.getElementById('first-name-count');
    var lnCount = document.getElementById('last-name-count');
    if (fnEl && fnCount) updateCharCount(fnEl, fnCount);
    if (lnEl && lnCount) updateCharCount(lnEl, lnCount);
    refresh();
  }
  var fnEl = document.getElementById('first-name');
  var lnEl = document.getElementById('last-name');
  if (fnEl) fnEl.addEventListener('input', onNameInput);
  if (lnEl) lnEl.addEventListener('input', onNameInput);

  /* ══════════════════════════════════════
     SECTION 2: BACKGROUND COLOR
  ══════════════════════════════════════ */
  document.querySelectorAll('.bg-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.bg-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var k = btn.dataset.bg;
      state.bgColor = BG_MAP[k] || k;
      var h = document.getElementById('hidden-bg-color');
      if (h) h.value = k;
      refresh();
    });
  });

  /* ══════════════════════════════════════
     SECTION 3: FONT COLOR
  ══════════════════════════════════════ */
  document.querySelectorAll('.color-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.color-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var c = btn.dataset.color;
      state.color = COLOR_MAP[c] || c;
      document.getElementById('hidden-font-color').value = c;
      refresh();
    });
  });

  /* ══════════════════════════════════════
     SECTION 4: FONT STYLE
  ══════════════════════════════════════ */
  document.querySelectorAll('.font-style-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.font-style-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var f = btn.dataset.font;
      state.fontFamily = FONT_MAP[f] || f;
      state.fontWeight = FONT_WEIGHT[f] || '700';
      document.getElementById('hidden-font-style').value = f;
      showFontHint(f);
      refresh();
      if (document.fonts && document.fonts.load) {
        document.fonts.load((state.fontWeight) + ' 20px ' + state.fontFamily).then(refresh).catch(function(){});
      }
    });
  });

  /* ══════════════════════════════════════
     SWIPE HELPER
  ══════════════════════════════════════ */
  function addSwipe(el, getOffset, setOffset, getMax) {
    var startX = 0, startOff = 0;
    var track = el.querySelector('[id]') || el.firstElementChild;
    el.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX; startOff = getOffset();
      if (track) track.style.transition = 'none';
    }, { passive: true });
    el.addEventListener('touchmove', function(e) {
      setOffset(Math.max(0, Math.min(getMax(), startOff + (startX - e.touches[0].clientX))));
    }, { passive: true });
    el.addEventListener('touchend', function() {
      if (track) track.style.transition = 'transform 0.3s ease';
      setOffset(Math.max(0, Math.min(getMax(), getOffset())));
    }, { passive: true });
  }

  /* ══════════════════════════════════════
     FONT CAROUSEL
  ══════════════════════════════════════ */
  (function () {
    var track   = document.getElementById('font-track');
    var outer   = document.querySelector('.font-carousel-track-outer');
    var prevBtn = document.getElementById('font-prev');
    var nextBtn = document.getElementById('font-next');
    if (!track || !prevBtn || !nextBtn) return;

    var COLS_VISIBLE = window.innerWidth <= 600 ? 3 : 4;
    var CARD_W       = 88;
    var total        = track.querySelectorAll('.font-style-btn').length;
    var totalCols    = Math.ceil(total / 2);
    var maxIndex     = Math.max(0, totalCols - COLS_VISIBLE);

    var _off = 0;
    function getOff() { return _off; }
    function getMax() { return maxIndex * CARD_W; }
    function setOff(v) {
      _off = v;
      track.style.transform = 'translateX(-' + v + 'px)';
      prevBtn.disabled = v <= 0;
      nextBtn.disabled = v >= getMax();
    }
    prevBtn.addEventListener('click', function() {
      track.style.transition = 'transform 0.3s ease'; setOff(Math.max(0, _off - CARD_W));
    });
    nextBtn.addEventListener('click', function() {
      track.style.transition = 'transform 0.3s ease'; setOff(Math.min(getMax(), _off + CARD_W));
    });
    if (outer) {
      addSwipe(outer, getOff, setOff, getMax);
      outer.addEventListener('scroll', function () { if (outer.scrollLeft) outer.scrollLeft = 0; });
    }
    setOff(0);
  })();

      function showFontHint(fontKey) {
    var el = document.getElementById('font-hint');
    if (!el) {
      var host = document.getElementById('font-section') || document.body;
      el = document.createElement('div');
      el.id = 'font-hint';
      host.appendChild(el);
    }
    var chars = FONT_HINT_CHARS[fontKey];
    if (!chars) { el.classList.remove('show'); el.innerHTML = ''; return; }

    el.innerHTML = '<span class="fh-label">Try the hidden cat icons! 🐱<br>Tap to copy, then add it to your name:</span>';
    var row = document.createElement('div');
    row.className = 'fh-chips';
    chars.forEach(function (ch) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fh-chip';
      b.textContent = ch;
      b.addEventListener('click', function () {
        if (navigator.clipboard) navigator.clipboard.writeText(ch).catch(function(){});
        b.classList.add('copied');
        setTimeout(function () { b.classList.remove('copied'); }, 900);
      });
      row.appendChild(b);
    });
    el.appendChild(row);
    el.classList.add('show');
  }

  /* ══════════════════════════════════════
     QUANTITY + ADD TO CART
  ══════════════════════════════════════ */
  (function () {
    var qty      = 1;
    var qtyVal   = document.getElementById('qty-value');
    var qtyInput = document.getElementById('form-quantity');

    document.getElementById('qty-minus').addEventListener('click', function () {
      if (qty > 1) { qty--; qtyVal.textContent = qty; qtyInput.value = qty; }
    });
    document.getElementById('qty-plus').addEventListener('click', function () {
      qty++; qtyVal.textContent = qty; qtyInput.value = qty;
    });

    var addBtn = document.querySelector('#custom-product-form .add-btn');
    var fInput = document.getElementById('first-name');
    if (!addBtn) return;

    addBtn.addEventListener('click', async function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (!state.firstName || state.firstName === 'Your name') {
        if (fInput) { fInput.focus(); fInput.classList.add('mt-shake'); setTimeout(function(){ fInput.classList.remove('mt-shake'); }, 500); }
        return;
      }

      var variantId = document.getElementById('form-variant-id').value;
      var q = parseInt(document.getElementById('form-quantity').value) || 1;

      var items = [{
        id: parseInt(variantId),
        quantity: q,
        properties: {
          'First Name':      state.firstName,
          'Last Name':       state.lastName,
          'Background Color':document.getElementById('hidden-bg-color').value,
          'Font Color':      document.getElementById('hidden-font-color').value,
          'Font Style':      document.getElementById('hidden-font-style').value,
          'Pattern Length':  document.getElementById('hidden-pattern-length').value
        }
      }];

      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!res.ok) { alert('Error adding to cart'); return; }

      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else document.querySelector('[aria-label="Cart"]')?.click();

      setTimeout(function() {
        fetch(window.location.href)
          .then(function(r){ return r.text(); })
          .then(function(html){
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newItems = doc.querySelector('cart-drawer-component cart-items-component');
            var curItems = document.querySelector('cart-drawer-component cart-items-component');
            if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;
          })
          .catch(function(err){ console.error('Drawer refresh failed', err); });
      }, 150);
    }, true);
  })();

  /* ─── INIT ─── */
  refresh();
  setTimeout(scalePreview, 60);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
  window.addEventListener('resize', refresh);

})();